(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var LINK_SELECTOR = '[data-sl-load-more]';
    var BUSY_CLASS = 'collection__load-more-link--busy';
    var CANCEL_CLASS = 'scroll-trigger--cancel';
    var REQUEST_TIMEOUT = 15000;
    // The theme's own look-ahead (product recommendations) uses 400px; this doubles it so the next
    // page is already arriving roughly two rows before the shopper reaches the end.
    var AUTO_LOAD_MARGIN = '0px 0px 800px 0px';

    // Slide ids restart at 1 on every rendered page, so they need offsetting to stay unique once
    // pages are concatenated. Leave --animation-order alone: it is a per-page cascade position,
    // not a grid-wide one.
    function offsetSlideIds(items, offset) {
      items.forEach(function (item, index) {
        if (item.id) item.id = item.id.replace(/-\d+$/, '-' + (offset + index + 1));
      });
    }

    function prepareForInjection(source) {
      // Cards injected into a live page skip the reveal animation, the same way facets.js does
      // after a filter swap. Animating them instead holds each card at opacity 0.01 for its full
      // `--animation-order * 75ms` delay, which reads as a blank gap where the new row should be.
      source.querySelectorAll('.scroll-trigger').forEach(function (element) {
        element.classList.add(CANCEL_CLASS);
      });
      // The component stylesheets each page carries are already in the document; adopting them
      // again would only litter the grid with dead nodes.
      source.querySelectorAll('link[rel="stylesheet"]').forEach(function (element) {
        element.remove();
      });
    }

    function setBusy(link, busy) {
      if (busy) link.setAttribute('aria-busy', 'true');
      else link.removeAttribute('aria-busy');
      link.classList.toggle(BUSY_CLASS, busy);
      var spinner = link.querySelector('.loading__spinner');
      if (spinner) spinner.classList.toggle('hidden', !busy);
    }

    function retire(link) {
      var wrapper = link.parentElement || link;
      // Removing the element that currently holds focus would drop the caret to <body>, so the
      // next Tab would restart at the top of the document. Hand it to the grid first.
      if (wrapper.contains(document.activeElement)) {
        var grid = document.getElementById(link.dataset.target);
        if (grid) {
          grid.setAttribute('tabindex', '-1');
          grid.focus({ preventScroll: true });
          // Take it back off once focus leaves: a permanently focusable <ul role="list"> would
          // swallow stray clicks on the grid's gutters and announce the whole list to a reader.
          grid.addEventListener(
            'blur',
            function () {
              grid.removeAttribute('tabindex');
            },
            { once: true }
          );
        }
      }
      wrapper.remove();
    }

    function loadNextPage(link, moveFocus, onDone) {
      function done(loaded) {
        if (onDone) onDone(loaded);
      }

      var page = parseInt(link.dataset.nextPage, 10);
      var totalPages = parseInt(link.dataset.totalPages, 10);
      // Unreadable counters mean the attributes were mangled — apps that re-render product grids
      // do drop unknown data-attributes. Leave the control alone rather than retiring it, for the
      // same reason a bad response does not retire it.
      if (isNaN(page) || isNaN(totalPages)) {
        setBusy(link, false);
        console.error('[featured-collection] unreadable paging state; leaving the link in place');
        done(false);
        return;
      }
      if (page > totalPages) {
        retire(link);
        done(false);
        return;
      }

      // Check before spending a request: the click handler guards this too, but the scroll-driven
      // caller does not, and discovering it after the round-trip wastes the fetch.
      if (!document.getElementById(link.dataset.target)) {
        done(false);
        return;
      }

      setBusy(link, true);

      // Browsers never time a fetch out on their own, and a request that never settles would leave
      // the link busy — and therefore unusable by pointer or keyboard — for the life of the page.
      var controller = new AbortController();
      var timer = setTimeout(function () {
        controller.abort();
      }, REQUEST_TIMEOUT);

      var url =
        link.dataset.rootUrl +
        '?section_id=' +
        encodeURIComponent(link.dataset.sectionId) +
        '&page=' +
        page;

      fetch(url, { signal: controller.signal })
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.text();
        })
        .then(function (html) {
          var rendered = new DOMParser().parseFromString(html, 'text/html');
          var source = rendered.getElementById(link.dataset.target);
          // A response without the grid at all is a bad response, not the end of the collection —
          // Shopify serves its generic error page with a 200 often enough that conflating the two
          // would let one blip retire the link for good, mid-list.
          if (!source) throw new Error('rendered section contained no grid');

          prepareForInjection(source);
          var items = Array.prototype.slice.call(source.children);
          if (items.length === 0) {
            retire(link);
            done(false);
            return;
          }

          // Re-resolve rather than trusting a reference taken before the request: an app or a
          // theme-editor reload may have replaced the grid, and appending to the detached node
          // would drop a whole page of products without a trace.
          var grid = document.getElementById(link.dataset.target);
          if (!grid) throw new Error('grid was replaced mid-request');

          offsetSlideIds(items, grid.children.length);
          // Each card holds a <product-component view-event-payload> with no view-event-trigger, so
          // on connect it observes itself and dispatches its view event once actually scrolled into
          // view. Left alone deliberately: appended cards then report on the same terms as the
          // server-rendered ones, rather than one grid telling analytics two different stories.
          items.forEach(function (item) {
            grid.appendChild(item);
          });

          link.dataset.nextPage = page + 1;
          setBusy(link, false);
          // Keyboard users need the caret to follow the content they just asked for; preventScroll
          // keeps this invisible to everyone else.
          if (moveFocus) {
            var firstAdded = items[0].querySelector('a');
            if (firstAdded) firstAdded.focus({ preventScroll: true });
          }
          revealBackToTop(link);
          if (page + 1 > totalPages) retire(link);
          done(true);
        })
        .catch(function (error) {
          // Leave the link exactly where it is so the shopper can try again. Navigating away on
          // failure would discard every page already loaded along with their place on the page.
          setBusy(link, false);
          if (error && error.name === 'AbortError') {
            console.warn('[featured-collection] load more timed out after ' + REQUEST_TIMEOUT + 'ms');
          } else {
            console.error('[featured-collection] load more failed:', error);
          }
          done(false);
        })
        .finally(function () {
          clearTimeout(timer);
        });
    }

    // Only worth offering once the grid has grown past what the shopper first landed on, and only
    // while they are far enough down it for it to do anything. Wired once: this runs on every
    // append, and each call would otherwise add another scroll listener.
    function revealBackToTop(link) {
      var section = link.closest('.shopify-section') || document;
      var button = section.querySelector('[data-sl-to-top]');
      if (!button || button.dataset.slWired) return;
      button.dataset.slWired = '1';

      var pending = false;
      var threshold = window.innerHeight;
      function sync() {
        pending = false;
        var next = (window.pageYOffset || 0) < threshold;
        // Only touch the attribute on a real change; this runs on every scroll frame.
        if (next === button.hidden) return;
        // Hiding display:none's the element, so if it holds focus the caret falls to <body> and
        // the next Tab restarts at the top of the document — the same hazard retire() avoids.
        if (next && button.contains(document.activeElement)) {
          var main = document.getElementById('MainContent');
          if (main) main.focus({ preventScroll: true });
          else button.blur();
        }
        button.hidden = next;
      }
      function schedule() {
        if (pending) return;
        pending = true;
        requestAnimationFrame(sync);
      }
      window.addEventListener('scroll', schedule, { passive: true });
      // The threshold is a viewport height, so it has to be re-read when the viewport changes —
      // rotating a phone otherwise leaves the button judged against the old orientation.
      window.addEventListener(
        'resize',
        function () {
          threshold = window.innerHeight;
          schedule();
        },
        { passive: true }
      );
      sync();
    }

    // The scroll-triggered half of this: load a few pages as the shopper approaches the end, then
    // hand back to the link so a long collection cannot bury the footer indefinitely.
    function startAutoLoad(link) {
      if (!('IntersectionObserver' in window)) return;
      var sentinel = link.parentElement;
      var budget = parseInt(link.dataset.autoLoad, 10);
      if (!sentinel || !budget) return;
      // init() runs on load and again on every shopify:section:load; without this a re-init would
      // attach a second observer with its own fresh budget and double the pages fetched.
      if (link.dataset.slAutoInit) return;
      link.dataset.slAutoInit = '1';

      var spent = 0;
      var failures = 0;
      var MAX_FAILURES = 2;
      // IntersectionObserver reports transitions, not states, so a sentinel still on screen after
      // an append would never fire again. Re-observing forces a fresh callback.
      function rearm() {
        observer.unobserve(sentinel);
        observer.observe(sentinel);
      }
      var observer = new IntersectionObserver(
        function (entries) {
          // Entries arrive batched, oldest first, so testing only entries[0] can miss an
          // [out, in] pair delivered in one callback — and this early return is the one path
          // that never re-arms, so a miss stalls auto-load until the shopper scrolls back up.
          var intersecting = entries.some(function (entry) {
            return entry.isIntersecting;
          });
          if (!intersecting) return;
          // A tick that lands while a click-driven load is in flight must still re-arm: the
          // observer only reports crossings, so returning bare here can leave it dormant if the
          // appended row does not push the sentinel back out of the look-ahead band.
          if (link.getAttribute('aria-busy') === 'true') {
            rearm();
            return;
          }
          if (spent >= budget) {
            observer.disconnect();
            return;
          }
          spent += 1;
          // Never move focus here: nobody asked for this page, so stealing the caret mid-scroll
          // would be hostile. A failure stops the observer rather than retrying into a wall.
          loadNextPage(link, false, function (loaded) {
            if (!document.contains(sentinel)) {
              observer.disconnect();
              return;
            }
            if (!loaded) {
              // Refund the attempt: a flaky response is not the end of the collection. Give up
              // only after repeated failures, rather than killing scroll-loading on one blip.
              spent -= 1;
              failures += 1;
              if (failures >= MAX_FAILURES) {
                observer.disconnect();
                return;
              }
              rearm();
              return;
            }
            if (spent >= budget) {
              observer.disconnect();
              return;
            }
            rearm();
          });
        },
        { rootMargin: AUTO_LOAD_MARGIN }
      );
      // Wait for a real scroll before arming. A grid shorter than the look-ahead would otherwise
      // satisfy the observer on load and spend the whole budget before the shopper moved — and
      // gating inside the callback instead would hit the no-re-arm stall described above.
      if ((window.pageYOffset || 0) > 0) {
        observer.observe(sentinel);
      } else {
        window.addEventListener(
          'scroll',
          function armOnce() {
            window.removeEventListener('scroll', armOnce);
            observer.observe(sentinel);
          },
          { passive: true, once: true }
        );
      }
    }

    function init(root) {
      (root || document).querySelectorAll(LINK_SELECTOR).forEach(startAutoLoad);
    }

    document.addEventListener('click', function (event) {
      if (!(event.target instanceof Element)) return;
      var toTop = event.target.closest('[data-sl-to-top]');
      if (toTop) {
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
        return;
      }

      var link = event.target.closest(LINK_SELECTOR);
      if (!link) return;
      // A modified click means "open the collection in a new tab". Swallowing it would make this
      // behave unlike the real anchor it is — and middle-click already bypasses this handler.
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      // With no grid to append to there is nothing this can do, so let the anchor navigate rather
      // than preventing default and leaving a control that visibly does nothing.
      if (!document.getElementById(link.dataset.target)) return;

      event.preventDefault();
      if (link.getAttribute('aria-busy') === 'true') return;
      // event.detail is 0 for activation via Enter/Space rather than a pointer.
      loadNextPage(link, event.detail === 0);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init();
      });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-banner-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('sl-banner-carousel')) return;

    class SlBannerCarousel extends HTMLElement {
      connectedCallback() {
        if (!this.initialized) {
          if (!this.setUp()) return;
          this.initialized = true;
        }
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
        this.reducedMotion.addEventListener('change', this.handleMotionChange);
        this.resizeObserver.observe(this.track);
        this.layout();
      }

      disconnectedCallback() {
        if (!this.initialized) return;
        clearInterval(this.timer);
        this.timer = null;
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        this.reducedMotion.removeEventListener('change', this.handleMotionChange);
        this.resizeObserver.disconnect();
      }

      // ── Navigation ──
      goTo(index) {
        // The track's `scroll-behavior` animates this (and turns it off under reduced motion).
        this.track.scrollTo({ left: index * this.stepWidth });
      }

      step(direction) {
        var target = this.currentIndex() + direction;
        if (target >= this.positions) target = 0;
        if (target < 0) target = this.positions - 1;
        this.goTo(target);
      }

      // ── Autoplay control ──
      pause(reason) {
        this.pauseReasons[reason] = true;
        clearInterval(this.timer);
        this.timer = null;
        this.track.setAttribute('aria-live', 'polite');
      }

      resume(reason) {
        delete this.pauseReasons[reason];
        this.startAutoplay();
      }

      // ── Internals ──
      setUp() {
        var self = this;
        this.track = this.querySelector('.sl-banners__track');
        this.slides = Array.prototype.slice.call(this.querySelectorAll('.sl-banners__slide'));
        this.dots = Array.prototype.slice.call(this.querySelectorAll('.sl-banners__dot'));
        if (!this.track || this.slides.length === 0) return false;

        this.pauseReasons = {};
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.handleVisibilityChange = function () {
          if (document.hidden) self.pause('hidden');
          else self.resume('hidden');
        };
        this.handleMotionChange = function () {
          self.startAutoplay();
        };
        this.resizeObserver = new ResizeObserver(function () {
          self.layout();
        });

        this.track.addEventListener(
          'scroll',
          function () {
            if (self.scrollFrame) return;
            self.scrollFrame = requestAnimationFrame(function () {
              self.scrollFrame = null;
              self.update();
            });
          },
          { passive: true }
        );

        // Rotation pauses while a mouse is over the carousel, while a keyboard user is inside it and
        // while a finger is on it. Swipes, dots and arrows never stop it: they restart the countdown,
        // so the banner the shopper picked stays up for a full interval.
        this.addEventListener('pointerenter', function (event) {
          if (event.pointerType === 'mouse') self.pause('hover');
        });
        this.addEventListener('pointerleave', function (event) {
          if (event.pointerType === 'mouse') self.resume('hover');
        });
        this.addEventListener('focusin', function (event) {
          if (self.isKeyboardFocus(event.target)) self.pause('focus');
        });
        this.addEventListener('focusout', function (event) {
          if (!self.contains(event.relatedTarget)) self.resume('focus');
        });
        ['touchend', 'touchcancel'].forEach(function (type) {
          self.track.addEventListener(
            type,
            function () {
              self.resume('touch');
            },
            { passive: true }
          );
        });
        this.track.addEventListener(
          'touchstart',
          function () {
            self.pause('touch');
          },
          { passive: true }
        );
        this.track.addEventListener(
          'wheel',
          function (event) {
            if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) self.startAutoplay();
          },
          { passive: true }
        );

        this.dots.forEach(function (dot, index) {
          dot.addEventListener('click', function () {
            self.goTo(index);
            self.startAutoplay();
          });
        });
        this.querySelectorAll('.sl-banners__arrow').forEach(function (button) {
          button.addEventListener('click', function () {
            self.step(button.name === 'next' ? 1 : -1);
            self.startAutoplay();
          });
        });
        return true;
      }

      layout() {
        var first = this.slides[0];
        var second = this.slides[1];
        this.stepWidth = second ? second.offsetLeft - first.offsetLeft : this.track.clientWidth;
        if (!this.stepWidth) return;
        this.perView = Math.max(1, Math.round(this.track.clientWidth / this.stepWidth));
        this.positions = Math.max(1, this.slides.length - this.perView + 1);
        this.update();
        this.startAutoplay();
      }

      // Banners scrolled out of view are hidden from screen readers and skipped by Tab, as in the
      // theme's slideshow; the dot for the leading banner is marked current.
      update() {
        var index = this.currentIndex();
        var perView = this.perView;
        this.slides.forEach(function (slide, slideIndex) {
          var visible = slideIndex >= index && slideIndex < index + perView;
          slide.setAttribute('aria-hidden', visible ? 'false' : 'true');
          slide.querySelectorAll('a').forEach(function (link) {
            if (visible) link.removeAttribute('tabindex');
            else link.setAttribute('tabindex', '-1');
          });
        });
        this.dots.forEach(function (dot, dotIndex) {
          if (dotIndex === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      startAutoplay() {
        var self = this;
        clearInterval(this.timer);
        this.timer = null;
        var blocked =
          this.dataset.autoplay !== 'true' ||
          this.reducedMotion.matches ||
          this.positions < 2 ||
          Object.keys(this.pauseReasons).length > 0;
        if (blocked) return;
        // Rotations are not announced, so a screen reader is never interrupted mid-sentence;
        // pausing restores announcements.
        this.track.setAttribute('aria-live', 'off');
        this.timer = setInterval(function () {
          self.step(1);
        }, (parseInt(this.dataset.speed, 10) || 6) * 1000);
      }

      currentIndex() {
        var index = Math.round(this.track.scrollLeft / this.stepWidth);
        return Math.max(0, Math.min(index, this.positions - 1));
      }

      // A tapped dot keeps focus, so only keyboard focus (what :focus-visible marks) holds rotation.
      isKeyboardFocus(element) {
        try {
          return element.matches(':focus-visible');
        } catch (error) {
          return true;
        }
      }
    }

    customElements.define('sl-banner-carousel', SlBannerCarousel);

    // Theme editor: bring the selected banner into view and hold rotation while it is selected.
    document.addEventListener('shopify:block:select', function (event) {
      var carousel = event.target.closest('sl-banner-carousel');
      if (!carousel || !carousel.initialized) return;
      carousel.pause('editor');
      carousel.goTo(Math.min(carousel.slides.indexOf(event.target), carousel.positions - 1));
    });
    document.addEventListener('shopify:block:deselect', function (event) {
      var carousel = event.target.closest('sl-banner-carousel');
      if (carousel && carousel.initialized) carousel.resume('editor');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-home-glass-reskin"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var CART_ADD = (window.routes && window.routes.cart_add_url) || '/cart/add';
    var CART_CHANGE = (window.routes && window.routes.cart_change_url) || '/cart/change';

    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    function refreshBubble() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          var link = document.getElementById('cart-icon-bubble');
          if (!link) return;
          var bubble = link.querySelector('.cart-count-bubble');
          if (cart.item_count > 0) {
            if (!bubble) {
              bubble = document.createElement('div');
              bubble.className = 'cart-count-bubble';
              link.appendChild(bubble);
            }
            // aria-hidden span for sighted users; visually-hidden span so a screen reader still
          // hears the count after an AJAX add — the theme's own bubble carries both.
          bubble.innerHTML =
            '<span aria-hidden="true">' + cart.item_count + '</span>' +
            '<span class="visually-hidden">' + cart.item_count + '</span>';
          } else if (bubble) {
            bubble.remove();
          }
          document.dispatchEvent(new CustomEvent('sl:cart-updated', { detail: cart }));
        })
        .catch(function () {});
    }

    // The cart page's line items and totals are server-rendered sections that the theme only
    // re-renders after its own quantity edits. A card add cancels the form submit (and with it the
    // theme's reload to the cart page), so re-render those sections in place, using the theme's own
    // section list and markup extraction from <cart-items>. No-op on pages without <cart-items>.
    var cartPageRefreshCount = 0;
    function refreshCartPage() {
      var cartItems = document.querySelector('cart-items');
      if (!cartItems) return;
      if (typeof cartItems.getSectionsToRender !== 'function') {
        window.location.reload();
        return;
      }
      var sections = cartItems.getSectionsToRender();
      var refreshNumber = ++cartPageRefreshCount;
      var url =
        window.location.pathname +
        '?sections=' +
        sections.map(function (section) { return section.section; }).join(',');
      // No JSON Accept header: /cart answers that with the cart object, not the sections map.
      fetch(url)
        .then(function (response) { return response.json(); })
        .then(function (rendered) {
          // Rapid steps overlap; only the newest render reflects the cart's final state.
          if (refreshNumber !== cartPageRefreshCount) return;
          sections.forEach(function (section) {
            var host = document.getElementById(section.id);
            if (!host || !rendered[section.section]) return;
            (host.querySelector(section.selector) || host).innerHTML = cartItems.getSectionInnerHTML(
              rendered[section.section],
              section.selector
            );
          });
          // `is-empty` lives on the section roots, outside the re-rendered markup.
          var isEmpty = !document.querySelector('#main-cart-items .cart-item');
          cartItems.classList.toggle('is-empty', isEmpty);
          var cartFooter = document.getElementById('main-cart-footer');
          if (cartFooter) cartFooter.classList.toggle('is-empty', isEmpty);
        })
        .catch(function () {});
    }

    function buildStepper(quick, variantId) {
      var stepper = quick.querySelector('.sl-stepper');
      if (stepper) return stepper;
      stepper = document.createElement('div');
      stepper.className = 'sl-stepper';
      stepper.innerHTML =
        '<button type="button" class="sl-step" data-sl-d="-1" aria-label="Decrease quantity">−</button>' +
        '<span class="sl-qty">1</span>' +
        '<button type="button" class="sl-step" data-sl-d="1" aria-label="Increase quantity">+</button>';
      quick.appendChild(stepper);
      stepper.addEventListener('click', function (event) {
        var stepBtn = event.target.closest('.sl-step');
        if (!stepBtn) return;
        var delta = parseInt(stepBtn.getAttribute('data-sl-d'), 10);
        var qtyEl = stepper.querySelector('.sl-qty');
        var next = Math.max(0, (parseInt(qtyEl.textContent, 10) || 0) + delta);
        changeQty(quick, variantId, next);
      });
      return stepper;
    }

    function showStepper(quick, variantId, qty) {
      var addBtn = quick.querySelector('.quick-add__submit, [type="submit"]');
      var stepper = buildStepper(quick, variantId);
      if (addBtn) addBtn.style.display = 'none';
      quick.classList.add('sl-has-stepper');
      stepper.style.display = 'flex';
      stepper.querySelector('.sl-qty').textContent = qty;
    }

    function hideStepper(quick) {
      var addBtn = quick.querySelector('.quick-add__submit, [type="submit"]');
      var stepper = quick.querySelector('.sl-stepper');
      if (stepper) stepper.style.display = 'none';
      quick.classList.remove('sl-has-stepper');
      if (addBtn) addBtn.style.display = '';
    }

    // The theme already renders a spinner inside every quick-add button and drives it with the
    // `loading` class; reuse it rather than inventing one, so it matches the rest of the store.
    function setButtonLoading(quick, on) {
      var addBtn = quick.querySelector('.quick-add__submit, [type="submit"]');
      if (!addBtn) return;
      var spinner = addBtn.querySelector('.loading__spinner');
      addBtn.classList.toggle('loading', on);
      addBtn.setAttribute('aria-busy', on ? 'true' : 'false');
      if (spinner) spinner.classList.toggle('hidden', !on);
    }

    function setStepperBusy(quick, on) {
      var stepper = quick.querySelector('.sl-stepper');
      if (!stepper) return;
      stepper.classList.toggle('sl-busy', on);
      stepper.setAttribute('aria-busy', on ? 'true' : 'false');
    }

    function addToCart(quick, variantId) {
      // Guard against a second tap (mobile double-tap) landing another add before the first
      // resolves, which would put two in the cart while the stepper shows one.
      if (quick.getAttribute('data-sl-adding')) return;
      quick.setAttribute('data-sl-adding', '1');
      setButtonLoading(quick, true);
      fetch(CART_ADD + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (response) { return response.json(); })
        .then(function (data) {
          quick.removeAttribute('data-sl-adding');
          setButtonLoading(quick, false);
          if (data && data.status) return;
          showStepper(quick, variantId, 1);
          refreshBubble();
          refreshCartPage();
        })
        .catch(function () {
          quick.removeAttribute('data-sl-adding');
          setButtonLoading(quick, false);
        });
    }

    function changeQty(quick, variantId, next) {
      setStepperBusy(quick, true);
      fetch(CART_CHANGE + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: String(variantId), quantity: next })
      })
        .then(function (response) { return response.json(); })
        .then(function () {
          setStepperBusy(quick, false);
          if (next <= 0) hideStepper(quick);
          else quick.querySelector('.sl-qty').textContent = next;
          refreshBubble();
          refreshCartPage();
        })
        .catch(function () { setStepperBusy(quick, false); });
    }

    function addCardLink(cardWrapper) {
      if (cardWrapper.querySelector('.sl-card-link')) return;
      var titleLink = cardWrapper.querySelector('.card__heading a[href]');
      if (!titleLink) return;
      var link = document.createElement('a');
      link.className = 'sl-card-link';
      link.href = titleLink.getAttribute('href');
      // The title link is the accessible one; this is a pointer-only duplicate, kept out of
      // the tab order. Do NOT mark it aria-hidden — a stylesheet on this store hides
      // [aria-hidden="true"] outright, which would take the hit target with it.
      link.setAttribute('tabindex', '-1');
      cardWrapper.appendChild(link);
    }

    // null until the initial /cart.js resolves. wireCard must not run before it is known: a card
    // wired without the map would miss the stepper for an item already in the cart, and the next
    // click would add a duplicate and desync the quantity.
    var slCartMap = null;
    var CARD_SELECTOR = 'slider-component .card-wrapper, .collection .card-wrapper, product-recommendations .card-wrapper';

    // Steppers only count their own taps. After a cart edit made elsewhere on the page, re-point
    // every wired card at the real cart, or its next tap would send a stale quantity.
    function syncSteppers(cart) {
      slCartMap = {};
      cart.items.forEach(function (item) { slCartMap[item.variant_id] = item.quantity; });
      document.querySelectorAll('.quick-add[data-sl-variant]').forEach(function (quick) {
        var variantId = quick.getAttribute('data-sl-variant');
        if (slCartMap[variantId]) showStepper(quick, variantId, slCartMap[variantId]);
        else hideStepper(quick);
      });
    }

    function wireCard(cardWrapper) {
      if (cardWrapper.getAttribute('data-sl-done')) return;
      var inner = cardWrapper.querySelector('.card--standard .card__inner, .card__inner');
      var quick = cardWrapper.querySelector('.quick-add');
      if (!inner || !quick) return;
      cardWrapper.setAttribute('data-sl-done', '1');

      addCardLink(cardWrapper);

      var addBtn = quick.querySelector('.quick-add__submit, [type="submit"]');
      // Out of stock: leave the theme's own disabled button in place and wire nothing to it.
      var soldOut = addBtn && (addBtn.disabled || addBtn.hasAttribute('disabled'));
      if (soldOut) return;

      var variantInput = quick.querySelector('input[name="id"]');
      var isSimpleAdd = !!(variantInput && quick.querySelector('product-form form'));

      if (isSimpleAdd && addBtn) {
        var variantId = variantInput.value;
        quick.setAttribute('data-sl-variant', variantId);
        // preventDefault alone is enough: the theme adds to cart from the form's `submit`
        // event, which a cancelled click never fires. Propagation is deliberately left
        // intact so other listeners on this button (app cart hooks, analytics) still run.
        addBtn.addEventListener('click', function (event) {
          event.preventDefault();
          addToCart(quick, variantId);
        });
        if (slCartMap[variantId]) showStepper(quick, variantId, slCartMap[variantId]);
      }
    }

    // Tag carousel sections for styling immediately (no wait, so there is no flash of the stock
    // design); behaviour is attached only once the cart map is known.
    function scopeSections() {
      document.querySelectorAll(CARD_SELECTOR).forEach(function (cardWrapper) {
        var section = cardWrapper.closest('.shopify-section');
        if (section) section.classList.add('sl-glass');
      });
    }

    function tick() {
      scopeSections();
      if (slCartMap === null) return;
      document.querySelectorAll(CARD_SELECTOR).forEach(wireCard);
    }

    function wireHeaderScroll() {
      var root = document.documentElement;
      var pending = false;
      function update() {
        pending = false;
        var offset = window.pageYOffset || root.scrollTop || 0;
        root.classList.toggle('sl-scrolled', offset > 24);
      }
      window.addEventListener(
        'scroll',
        function () {
          if (pending) return;
          pending = true;
          requestAnimationFrame(update);
        },
        { passive: true }
      );
      update();
    }

    function run() {
      var rootClasses = document.documentElement.classList;
      // Site-wide bootstrap (layout/theme.liquid) sets these on <html> pre-paint: `sl-glass-page`
      // (glass header/toolbar — every page) and `sl-glass-boot` (card glassing + anti-FOUC — the
      // card templates, incl. the cart's carousel). Some pages get the header but have no cards.
      var doHeader = rootClasses.contains('sl-glass-page');
      var doCards = rootClasses.contains('sl-glass-boot');
      if (!doHeader && !doCards) return;
      if (doHeader) wireHeaderScroll();
      if (!doCards) return; // header-only pages (e.g. account/policy) get the toolbar, no card work
      scopeSections();
      // FOUC backstop: reveal any still-hidden reskin cards even if a section escaped tagging, or
      // where CSS animations are disabled (the keyframe failsafe wouldn't fire then).
      setTimeout(function () { document.documentElement.classList.add('sl-glass-revealed'); }, 1200);
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          slCartMap = {};
          (cart.items || []).forEach(function (item) { slCartMap[item.variant_id] = item.quantity; });
          tick();
        })
        .catch(function () { slCartMap = {}; tick(); });

      // The theme's cart list (quantity edits, remove) publishes cartUpdate with the full cart.
      // Publishers that send only the added line carry no `items` and are ignored.
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
          if (event && event.cartData && event.cartData.items) syncSteppers(event.cartData);
        });
      }

      var pending = null;
      var observer = new MutationObserver(function () {
        if (pending) return;
        pending = setTimeout(function () {
          pending = null;
          tick();
        }, 300);
      });
      observer.observe(document.body, { childList: true, subtree: true });
      [800, 2000].forEach(function (delay) {
        setTimeout(tick, delay);
      });
    }

    ready(run);
  })();

  } catch(e) { console.error(e); }
})();
})();
